var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-wrap"},[_c('div',{staticClass:"spinner"},_vm._l((_vm.nodes),function(n){return _c('i',{key:n.angle,style:(n)})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }